export var source = "fragment Products on ProductLineItem {\n  id\n  quantity\n  price\n  product {\n    ...Product\n  }\n}";
import { source as fragment1 } from "./product.graphql";
var combined = source  + "\n" + fragment1;
export default combined;